import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface subAdminState {
	isLoading: boolean;
	subAdminList: any;
	totalsubAdmin: number;
	subAdminDetail: any;
	roles: any;

}

const initialState: subAdminState = {
	isLoading: false,
	subAdminList: [],
	subAdminDetail: {},
	totalsubAdmin: 0,
	roles: []
};

const subAdminSlice = createSlice({
	name: 'subAdmin',
	initialState,
	reducers: {
		getAllsubAdminInIt: state => {
			state.isLoading = true;
		},
		getAllsubAdminSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			// console.log("DATA", data.count)
			state.isLoading = false;
			state.totalsubAdmin = data.count;
			state.subAdminList = [...data.subAdminList];
		},
		getAllsubAdminError: state => {
			state.isLoading = false;
			state.subAdminList = [];
			state.totalsubAdmin = 0;
		},
		deletesubAdminInit: state => {
			state.isLoading = true;
		},
		deletesubAdminSuccess: state => {
			state.isLoading = false;
		},
		deletesubAdminError: state => {
			state.isLoading = false;
		},
		addsubAdminInIt: state => {
			state.isLoading = true;
		},
		addsubAdminSuccess: state => {
			state.isLoading = false;
		},
		addsubAdminError: state => {
			state.isLoading = false;
		},
		getsubAdminByIdInIt: state => {
			state.isLoading = true;
		},
		getRolesUpdate: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.roles = [...action.payload.roles];
		},
		getsubAdminByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.subAdminDetail = { ...action.payload.data.subAdmin };
		},
		getsubAdminByIdError: state => {
			state.isLoading = false;
		},
		clearsubAdminDetail: state => {
			state.subAdminDetail = {};
		},


		updateSubAdminStatusInit: state => {
			state.isLoading = true;
		},
		updateSubAdminStatusSuccess: state => {
			// state.isLoading = true;
		},
		updateSubAdminStatusError: state => {
			state.isLoading = false;
		},

	}
});
export const {
	updateSubAdminStatusInit,
	updateSubAdminStatusSuccess,
	updateSubAdminStatusError,
	addsubAdminError,
	addsubAdminInIt,
	addsubAdminSuccess,
	clearsubAdminDetail,
	deletesubAdminError,
	deletesubAdminInit,
	deletesubAdminSuccess,
	getAllsubAdminError,
	getAllsubAdminInIt,
	getAllsubAdminSuccess,
	getsubAdminByIdError,
	getsubAdminByIdInIt,
	getsubAdminByIdSuccess,
	getRolesUpdate
} = subAdminSlice.actions;

export default subAdminSlice.reducer;
